import { render, staticRenderFns } from "./principle.vue?vue&type=template&id=1e62dd5d&scoped=true"
import script from "./principle.vue?vue&type=script&lang=js"
export * from "./principle.vue?vue&type=script&lang=js"
import style0 from "./principle.vue?vue&type=style&index=0&id=1e62dd5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e62dd5d",
  null
  
)

export default component.exports